import { render, staticRenderFns } from "./externalSystem.vue?vue&type=template&id=17723e78&scoped=true"
import script from "./externalSystem.vue?vue&type=script&lang=js"
export * from "./externalSystem.vue?vue&type=script&lang=js"
import style0 from "./externalSystem.vue?vue&type=style&index=0&id=17723e78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17723e78",
  null
  
)

export default component.exports